import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AddPartyContainer } from '@app/my-zone/shared/involved-parties/add-party/add-party.container';
import { InvolvedPartiesContainer } from '@app/my-zone/shared/involved-parties/involved-parties.container';
import { CynoFormModule } from '@app/shared/cyno-form/cyno-form.module';
import { WucIconUiModule } from '@inshared/website-ui-components';
import { NewModalModule } from 'outshared-lib';
import { AddPartyComponent } from './add-party/add-party.component';
import { InvolvedRoleComponent } from './add-party/involved-role/involved-role.component';
import { InvolvedPartiesComponent } from './involved-parties.component';
import { AddPartyModalComponent } from './party/add-party-modal/add-party-modal.component';
import { PartyComponent } from './party/party.component';

@NgModule({
    declarations: [
        InvolvedPartiesComponent,
        AddPartyComponent,
        PartyComponent,
        AddPartyContainer,
        AddPartyModalComponent,
        InvolvedPartiesContainer,
        InvolvedRoleComponent,
    ],
    imports: [CommonModule, CynoFormModule, NewModalModule, WucIconUiModule],
    exports: [InvolvedPartiesContainer, AddPartyContainer],
})
export class InvolvedPartiesModule {}
